var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        { staticClass: "mt-2" },
        [
          _c(
            "v-speed-dial",
            { attrs: { hover: _vm.hover, direction: _vm.direction } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    slot: "activator",
                    color: "blue darken-2",
                    dark: "",
                    hover: "",
                  },
                  slot: "activator",
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("date_range")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("Button.Date_Range_Shortcuts")) +
                      "\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(Object.keys(_vm.dateRangeShortcuts), function (range) {
                return _c(
                  "v-btn",
                  {
                    key: range,
                    staticStyle: { "z-index": "5", margin: "2px" },
                    attrs: { color: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.setNewDateRange(range)
                      },
                    },
                  },
                  [_vm._v(_vm._s(range))]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }